import { ButtonBase, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { OnlinePill } from '@/components/Common/online-pill.tsx';

interface Props {
    name: string;
    isOnline: boolean;
    isSelected: boolean;
    onSelect: () => void;
    meta?: string;
    dataTestId?: string;
}

const useStyles = makeStyles((theme: any) => ({
    card: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '0.75rem',
        width: '100%',
        boxSizing: 'border-box',
        minHeight: '3.25rem',
        padding: '0.75rem 1rem',
        backgroundColor: theme.palette.common.white,
        border: theme.border.light,
        borderRadius: theme.radius.field,
        textAlign: 'left',
        cursor: 'pointer',
        transition: 'border-color 200ms ease',
        '&:hover': {
            borderColor: theme.palette.common.yellow,
        },
        '&:focus-visible': {
            outline: `2px solid ${theme.palette.common.darkGrey}`,
            outlineOffset: -4,
        },
    },
    selected: {
        borderColor: theme.palette.common.yellow,
        backgroundColor: theme.palette.common.lightBrown,
    },
    content: {
        flex: 1,
        minWidth: 0,
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        flexWrap: 'wrap',
    },
    name: {
        ...theme.typography.body1,
        color: theme.palette.common.darkGrey,
        margin: 0,
        minWidth: 0,
        overflowWrap: 'anywhere',
    },
    chevron: {
        flex: 'none',
        color: theme.palette.common.darkGrey,
        opacity: 0.4,
    },
    meta: {
        display: 'block',
        ...theme.typography.body2,
        color: theme.palette.common.darkGrey,
        opacity: 0.5,
        margin: '0.25rem 0 0',
    },
}));

export const TreatmentTypeCard = ({ name, isOnline, isSelected, onSelect, meta, dataTestId }: Props) => {
    const classes = useStyles();
    return (
        <ButtonBase
            className={clsx(classes.card, isSelected && classes.selected)}
            onClick={onSelect}
            aria-pressed={isSelected}
            data-testid={dataTestId}
        >
            <span className={classes.content}>
                <span className={classes.label}>
                    <Typography className={classes.name} component="span">
                        {name}
                    </Typography>
                    {isOnline && <OnlinePill />}
                </span>
                {meta && (
                    <Typography className={classes.meta} component="span">
                        {meta}
                    </Typography>
                )}
            </span>
            <span className={classes.chevron} aria-hidden="true">
                ›
            </span>
        </ButtonBase>
    );
};
